import { sbaAxios } from "../utils/sbaAxios";
import {
        FETCH_PUBLICEXPOSUREASSETS_BEGIN,
        FETCH_PUBLICEXPOSUREASSETS_SUCCESS,
        FETCH_PUBLICEXPOSUREASSETS_FAILURE,
        FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN,
        FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS,
        FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE,
        FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN,
        FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS,
    FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE,
    FETCH_PUBLICEXPOSURETSCHART_BEGIN,
    FETCH_PUBLICEXPOSURETSCHART_FAILURE,
    FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS,
    FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS,
    FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS,
    FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS,

    FETCH_GETOVERLAPASSET_BEGIN,
    FETCH_GETOVERLAPASSET_SUCCESS,
    FETCH_GETOVERLAPASSET_FAILURE,

    
    } from '../constants/publicExposure'
import { getPublicExposureAssets, getPublicExposureMinMaxAssetDates, getPublicExposureOverlapAnalysisReportData, getPublicExposureTSCharts, getOverlapAssetsforUniverse } from '../../config/apiConfig';

export const getAssetsListDataAction=(searchText, isContains)=>{ 
  return async (dispatch) => {
    dispatch(getAssetsListDataActionBegin());
    try {
        const response = await sbaAxios({
            url: `${getPublicExposureAssets}searchText=${searchText}&isContains=${isContains}`,
            method: 'get',
        })
        const PublicExposureAssetsList = response;
        dispatch(getAssetsListDataActionSuccess(PublicExposureAssetsList));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getAssetsListDataActionSuccess({}));
        } else {
          dispatch(getAssetsListDataActionFailure(error));
        }
      }
  };
}

export const getAssetsListDataActionBegin = () => ({
    type: FETCH_PUBLICEXPOSUREASSETS_BEGIN,
  });
  
  export const getAssetsListDataActionSuccess = (PublicExposureAssetsList) => ({
    type: FETCH_PUBLICEXPOSUREASSETS_SUCCESS,
    payload: {PublicExposureAssetsList},
  });
  
  
  export const getAssetsListDataActionFailure = (errorMessage) => ({
    type: FETCH_PUBLICEXPOSUREASSETS_FAILURE,
    payload: {errorMessage}
  });
  
  export const getMinMaxAssetDatesDataAction=(assetId)=>{ 
    return async (dispatch) => {
      dispatch(getMinMaxAssetDatesDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getPublicExposureMinMaxAssetDates}${assetId}`,
              method: 'get',
          })
          const MinMaxAssetDates = response;
          dispatch(getMinMaxAssetDatesDataActionSuccess(MinMaxAssetDates));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getMinMaxAssetDatesDataActionSuccess({}));
          } else {
            dispatch(getMinMaxAssetDatesDataActionFailure(error));
          }
        }
    };
  }
  
  export const getMinMaxAssetDatesDataActionBegin = () => ({
      type: FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN,
    });
    
    export const getMinMaxAssetDatesDataActionSuccess = (PublicExposureAssetsList) => ({
      type: FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS,
      payload: {PublicExposureAssetsList},
    });
    
    
    export const getMinMaxAssetDatesDataActionFailure = (errorMessage) => ({
      type: FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE,
      payload: {errorMessage}
    });

    export const getOverlapAnalysisReportDataAction=(assetId)=>{ 
      return async (dispatch) => {
        dispatch(getOverlapAnalysisReportDataActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getPublicExposureOverlapAnalysisReportData}${assetId}`,
                method: 'get',
            })
            const OverlapAnalysisReportData = response;
            dispatch(getOverlapAnalysisReportDataActionSuccess(OverlapAnalysisReportData));
          } catch (error) {
            if (error.message === 'Network Error') {
              dispatch(getOverlapAnalysisReportDataActionSuccess({}));
            } else {
              dispatch(getOverlapAnalysisReportDataActionFailure(error));
            }
          }
      };
    }
    
    export const getOverlapAnalysisReportDataActionBegin = () => ({
        type: FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN,
      });
      
      export const getOverlapAnalysisReportDataActionSuccess = (OverlapAnalysisReportData) => ({
        type: FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS,
        payload: {OverlapAnalysisReportData},
      });
      
      
      export const getOverlapAnalysisReportDataActionFailure = (errorMessage) => ({
        type: FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE,
        payload: {errorMessage}
      });



export const getExposureTsOptionEquityChartAction = (assetId, startDate, endDate, chartName, incOption, techDef, outputData) => {
    return async (dispatch) => {
        dispatch(getExposureTsChartActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getPublicExposureTSCharts}${assetId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&incOption=${incOption}&techDef=${techDef}&outputData=${outputData}`,
                method: 'get',
            })
            const EquityChart = response;
            dispatch(getExposureTsOptionEquityChartSuccess(EquityChart));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getExposureTsOptionEquityChartSuccess({}));
            } else {
                dispatch(getExposureTsChartActionFailure(error));
            }
        }
    };
}

export const getExposureTsChartActionBegin = () => ({
    type: FETCH_PUBLICEXPOSURETSCHART_BEGIN,
});

export const getExposureTsOptionEquityChartSuccess = (EquityChart) => ({
    type: FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS,
    payload: { EquityChart },
});


export const getExposureTsChartActionFailure = (errorMessage) => ({
    type: FETCH_PUBLICEXPOSURETSCHART_FAILURE,
    payload: { errorMessage }
});


export const getExposureTsCurrentSectorChartAction = (assetId, startDate, endDate, chartName, incOption, techDef, outputData) => {
    return async (dispatch) => {
        dispatch(getExposureTsChartActionBegin());
        try {

            const response = await sbaAxios({
                url: `${getPublicExposureTSCharts}${assetId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&incOption=${incOption}&techDef=${techDef}&outputData=${outputData}`,
                method: 'get',
            })
            const CurrentSectorChart = response;
            dispatch(getExposureTsCurrentSectorChartSuccess(CurrentSectorChart));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getExposureTsCurrentSectorChartSuccess({}));
            } else {
                dispatch(getExposureTsChartActionFailure(error));
            }
        }
    };
}

export const getExposureTsCurrentSectorChartSuccess = (CurrentSectorChart) => ({
    type: FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS,
    payload: { CurrentSectorChart },
});



export const getExposureTsSectorNoOpChartAction = (assetId, startDate, endDate, chartName, incOption, techDef, outputData) => {
    return async (dispatch) => {
        dispatch(getExposureTsChartActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getPublicExposureTSCharts}${assetId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&incOption=${incOption}&techDef=${techDef}&outputData=${outputData}`,
                method: 'get',
            })
            const SectorNoOpChart = response;
            dispatch(getExposureTsSectorNoOpChartSuccess(SectorNoOpChart));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getExposureTsSectorNoOpChartSuccess({}));
            } else {
                dispatch(getExposureTsChartActionFailure(error));
            }
        }
    };
}

export const getExposureTsSectorNoOpChartSuccess = (SectorNoOpChart) => ({
    type: FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS,
    payload: { SectorNoOpChart },
});

export const getExposureTsSectorChartAction = (assetId, startDate, endDate, chartName, incOption, techDef, outputData) => {
    return async (dispatch) => {
        dispatch(getExposureTsChartActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getPublicExposureTSCharts}${assetId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&incOption=${incOption}&techDef=${techDef}&outputData=${outputData}`,
                method: 'get',
            })
            const SectorChart = response;
            dispatch(getExposureTsSectorChartSuccess(SectorChart));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getExposureTsSectorChartSuccess({}));
            } else {
                dispatch(getExposureTsChartActionFailure(error));
            }
        }
    };
}

export const getExposureTsSectorChartSuccess = (SectorChart) => ({
    type: FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS,
    payload: { SectorChart },
});


export const GetOverlapAssetsforUniverseAction = (universeId) => {
    return async (dispatch) => {
        dispatch(getOverlapAssetsforUniverseBegin());
        try {
            const response = await sbaAxios({
                url: `${getOverlapAssetsforUniverse}${universeId}`,
                method: 'get',
            })    
            const AssetsforUniverse = response;
            dispatch(getOverlapAssetsforUniverseSuccess(AssetsforUniverse));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getOverlapAssetsforUniverseSuccess({}));
            } else {
                dispatch(getOverlapAssetsforUniverseFailure(error));
            }
        }
    };
}

export const getOverlapAssetsforUniverseSuccess = (AssetsforUniverse) => ({
    type: FETCH_GETOVERLAPASSET_SUCCESS,
    payload: { AssetsforUniverse },

});
    export const getOverlapAssetsforUniverseFailure = (errorMessage) => ({
        type: FETCH_GETOVERLAPASSET_FAILURE,
        payload: { errorMessage }
    
});


export const getOverlapAssetsforUniverseBegin = () => ({
    type: FETCH_GETOVERLAPASSET_BEGIN,
});
